import { CalculatorDescription } from '../../../lib/calculators/calculator-description';
import { CalculatorId } from '../../../lib/calculators/calculator-config';

export const nightingaleRoseDescription: CalculatorDescription = {
  id: CalculatorId.NightingaleChart,
  title: 'Nightingale Rose Chart Maker',
  metaTitle: 'Free Online Nightingale Rose Chart Maker - Create Polar Area Diagrams',
  description: 'Create Nightingale Rose charts (polar area diagrams) to visualize cyclic data and compare quantities. Perfect for seasonal patterns, periodic data, and comparative analysis.',
  metaDescription: 'Make professional Nightingale Rose charts online. Create polar area diagrams with our free tool. Visualize cyclic data and patterns effectively.',
  howTo: {
    title: 'How to Create a Nightingale Rose Chart',
    steps: [
      'Enter your data in the table or paste from spreadsheet',
      'Select the category column for the segments',
      'Select the value column for the segment sizes',
      'Choose between radius and area scaling',
      'Customize labels and appearance',
      'Download or share your chart'
    ],
    graphic: {
      description: 'A step-by-step guide showing how to create a Nightingale Rose chart from data input to final visualization'
    }
  },
  examples: [
    {
      title: 'Monthly Disease Cases',
      description: 'Disease incidence patterns throughout the year',
      dataDescription: 'Monthly case counts with seasonal variation',
      insights: [
        'Peak cases occur during winter months',
        'Summer months show lowest incidence',
        'Clear seasonal pattern visible',
        'Transition periods in spring and fall'
      ]
    },
    {
      title: 'Hourly Website Traffic',
      description: 'Website traffic distribution over 24 hours',
      dataDescription: 'Hourly visitor counts showing daily patterns',
      insights: [
        'Peak traffic during business hours',
        'Significant drop during night hours',
        'Gradual increase in morning hours',
        'Secondary peak in evening'
      ]
    },
    {
      title: 'Annual Weather Patterns',
      description: 'Temperature and precipitation patterns by month',
      dataDescription: 'Monthly climate data showing yearly cycles',
      insights: [
        'Highest temperatures in summer months',
        'Peak rainfall in spring season',
        'Driest period in winter',
        'Clear seasonal transitions'
      ]
    }
  ],
  relatedCalculators: [
    CalculatorId.PieChart,
    CalculatorId.DonutChart,
    CalculatorId.BarGraph
  ]
}; 